import $ from 'jquery';
import _ from 'underscore';
import { register } from '../../core/bootstrapper';
import SearchFieldView from './searchFieldView';
import SearchFieldModel from './searchFieldModel';

register(null, function() {
  _.each($('.search-block'), function(el) {
    new SearchFieldView({
      el: el,
      model: new SearchFieldModel()
    });
  });
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/searchField/searchFieldBootstrap.js
 **/